import { IDocument } from 'src/interfaces/document';
import { DOCUMENT_TITLES } from 'src/modules/conversations/constants/documents';
import { CapitalizeNames } from 'src/utils/capitalize';

/**
 * Formats a document description for display, including translated title and optional vehicle model.
 *
 * If the document title is in the DOCUMENT_TITLES list, it will be translated using the provided
 * translation function. Otherwise, the raw (capitalized) title is used. If the document has an associated
 * vehicle, its model name will be appended in parentheses.
 *
 * @param item - The document to format.
 * @param t - Translation function used to localize known document titles.
 * @returns A formatted string containing the document title, description, and optional vehicle model.
 */
export const formatDocumentDescription = (
    item: IDocument,
    t: Function
): string => {
    let title: string;

    if (item && DOCUMENT_TITLES.includes(item.title)) {
        title = t(`Documents.${item.title}`);
    } else {
        title = CapitalizeNames(item?.title || '');
    }

    const description = item?.description || '';
    const vehicleModel = item?.vehicle
        ? `(${CapitalizeNames(item?.vehicle?.model || '')})`
        : '';

    return `${title} ${description} ${vehicleModel}`.trim();
};
